import { InboxMessageCriteria } from '@src/main/modules/messages/domain/message/inbox/inbox-message-criteria.interface';
import { createInboxMessageHttpRepository } from '@src/main/modules/messages/infrastructure/repository/InboxMessageHttpRepository';
import { createOutboxMessageHttpRepository } from '@src/main/modules/messages/infrastructure/repository/OutboxMessageHttpRepository';
import { Incident } from '@src/main/modules/other_incidents/domain/incident.model';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

type SendIncidentEmailParams = {
  incident: Incident;
  user: { fullName: string; email: string } | null;
  plainText?: string;
  htmlText?: string;
  file?: File | null;
};

export const findAnswerEmailUseCase = async (
  tokenProvider: TokenProvider,
  subject: string,
  sendDateFrom: string,
  recipient: string,
): Promise<string> => {
  const inboxRepository = createInboxMessageHttpRepository(tokenProvider);
  const criteria: InboxMessageCriteria = {
    page: 0,
    size: 1,
    subject,
    sortOrder: -1,
    sortField: 'sendDate',
    sendDateFrom,
    recipient,
    includeOtherIncident: true,
  };
  const response = await inboxRepository.findByCriteria(criteria);
  const message = response.items[0]?.message;

  return message;
};

export const sendIncidentEmailUseCase = async (
  { incident, user, plainText, htmlText, file }: SendIncidentEmailParams,
  tokenProvider: TokenProvider,
): Promise<void> => {
  if (!htmlText?.trim() && !plainText?.trim()) {
    throw new Error('EMPTY_MESSAGE');
  }

  const outboxRepository = createOutboxMessageHttpRepository(tokenProvider);

  const signatureText = ` 

Saludos,
${user?.fullName || ''}
Apoyo al Vuelo`;

  const signatureHtml = `<br/><br/>
  <p>Saludos,</p><br/>
  <p><strong>${user?.fullName || ''}</strong></p><br/>
  <p>Apoyo al Vuelo</p>`;

  await outboxRepository.createMessage({
    subject: `Incidencia vuelo ${incident.flightNumber}`,
    subjectSelected: 'Incidencias Columbus',
    sendBy: user?.email || '',
    sendByName: user?.fullName || '',
    message: `${plainText || ''}${signatureText}`,
    messageHtml: `${htmlText || ''}${signatureHtml}`,
    file: file || undefined,
    recipients: [
      {
        recipient: incident.employeeEmail || '',
        recipientName: incident.employeeName || '',
      },
    ],
  });
};
